'use client'

import { useBrowserExtensionToast } from '@/hooks/useBrowserExtensionToast'

export const BrowserExtensionToaster = () => {
  useBrowserExtensionToast()

  return null
}
